<template>
  <div class="ag-risco-matriz">
    <div class="ag-risco-matriz__y-title">Prioridade</div>

    <div class="ag-risco-matriz__y-label">{{ getDescriptionForPrioridade(MATRIZ_EXPOSICAO_PRIORIDADE.ALTA) }}</div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.ELEVADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.ELEVADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.CRITICO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.CRITICO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.CRITICO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.CRITICO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.CRITICO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.CRITICO) }}
    </div>

    <div class="ag-risco-matriz__y-label">{{ getDescriptionForPrioridade(MATRIZ_EXPOSICAO_PRIORIDADE.MEDIA) }}</div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.MODERADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.MODERADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.ELEVADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.ELEVADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.CRITICO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.CRITICO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.CRITICO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.CRITICO) }}
    </div>

    <div class="ag-risco-matriz__y-label">{{ getDescriptionForPrioridade(MATRIZ_EXPOSICAO_PRIORIDADE.BAIXA) }}</div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.BAIXO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.BAIXO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.MODERADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.MODERADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.ELEVADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.ELEVADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.ELEVADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.ELEVADO) }}
    </div>

    <div class="ag-risco-matriz__y-label">{{ getDescriptionForPrioridade(MATRIZ_EXPOSICAO_PRIORIDADE.NULA) }}</div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.INEXPRESSIVO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.INEXPRESSIVO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.MODERADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.MODERADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.ELEVADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.ELEVADO) }}
    </div>
    <div class="ag-risco-matriz__cell" :class="getClass(NIVEL_RISCO.ELEVADO)">
      {{ getDescriptionForGrauRisco(NIVEL_RISCO.ELEVADO) }}
    </div>

    <div class="ag-risco-matriz__cell--empty"></div>
    <div class="ag-risco-matriz__cell--empty"></div>
    <div class="ag-risco-matriz__x-label">{{ getDescriptionForImpacto(MATRIZ_EXPOSICAO_IMPACTO.IRRELEVANTE) }}</div>
    <div class="ag-risco-matriz__x-label">{{ getDescriptionForImpacto(MATRIZ_EXPOSICAO_IMPACTO.INSIGNIFICANTE) }}</div>
    <div class="ag-risco-matriz__x-label">{{ getDescriptionForImpacto(MATRIZ_EXPOSICAO_IMPACTO.MEDIO) }}</div>
    <div class="ag-risco-matriz__x-label">{{ getDescriptionForImpacto(MATRIZ_EXPOSICAO_IMPACTO.CRITICO) }}</div>

    <div class="ag-risco-matriz__cell--empty"></div>
    <div class="ag-risco-matriz__cell--empty"></div>
    <div class="ag-risco-matriz__x-title">Impacto</div>
  </div>
</template>

<script>
import MATRIZ_EXPOSICAO_IMPACTO from '@/constants/ConstantMatrizExposicaoImpacto';
import MATRIZ_EXPOSICAO_PRIORIDADE from '@/constants/ConstantMatrizExposicaoPrioridade';
import NIVEL_RISCO from '@/constants/ConstantNivelRisco';
import UtilsAnalise from '@/utils/UtilsAnalise';

export default {
  data: () => ({
    NIVEL_RISCO,
    MATRIZ_EXPOSICAO_IMPACTO,
    MATRIZ_EXPOSICAO_PRIORIDADE,
  }),
  methods: {
    getDescriptionForGrauRisco: UtilsAnalise.getDescriptionForGrauRisco,
    getDescriptionForImpacto: UtilsAnalise.getDescriptionForImpacto,
    getDescriptionForPrioridade: UtilsAnalise.getDescriptionForPrioridade,

    getClass(grauRisco) {
      return `ag-risco-matriz__cell--${grauRisco}`;
    },
  },
};
</script>

<style scoped lang="scss">
.ag-risco-matriz {
  width: 100%;

  display: grid;
  grid-template-columns: 32px 52px repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr) 32px 32px;
  gap: 0;

  font-size: $font-size-xxxs;
  color: $neutral-color-high-light;

  border-radius: $border-radius-sm;
  overflow: hidden;
}

.ag-risco-matriz__x-title,
.ag-risco-matriz__y-title {
  background: $neutral-color-low-dark;
}

.ag-risco-matriz__x-title {
  padding: 4px;
  grid-column: span 4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ag-risco-matriz__y-title {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
  grid-row: span 4;
}

.ag-risco-matriz__x-label {
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ag-risco-matriz__y-label {
  padding: 4px 8px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ag-risco-matriz__cell {
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ag-risco-matriz__label {
  text-align: center;
  background: #ffffff;
  padding: 4px;
}

.ag-risco-matriz__cell--INEXPRESSIVO {
  background: $neutral-color-high-light;
  color: #fff;
}

.ag-risco-matriz__cell--BAIXO {
  background: $feedback-color-success-flourescent;
  color: #fff;
}

.ag-risco-matriz__cell--MODERADO {
  background: $feedback-color-attention-flourescent;
  color: $feedback-color-attention-dark;
}

.ag-risco-matriz__cell--ELEVADO {
  background: $feedback-color-more-attention-flourescent;
  color: $feedback-color-more-attention-dark;
}

.ag-risco-matriz__cell--CRITICO {
  color: #ffffff;
  background: $feedback-color-error-flourescent;
}
</style>
